import { Autocomplete, TextField } from '@mui/material';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { BiSave } from 'react-icons/bi';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ListStatusProduct } from 'services/commonDate_services';
import { ProductDetail } from 'services/product_services';
import * as rootStore from 'stores/root_store';
import { useCheckPermission } from 'utils/permissionHelper';

export type EditProduct = {
  productId: string;
  lastMaintenanceDate?: Date | null;
  buyDate?: Date | null;
  testDate?: Date | null;
  usedDate?: Date | null;
  MoldTest?: string;
  maintenanceAlert?: number;
  currentStampeQuantity?: number;
  stampQuantityAlert?: number;
  actived: string;
  status?: string;
  ghiChu?: string;

  moldDrawCode?: string;
  printMoldFilm?: string;
  printMoldName?: string;
  bin?: string;
};

const activeOptions = [
  {
    key: 'active',
    value: 'Sử dụng',
  },
  {
    key: 'unactive',
    value: 'Không sử dụng',
  },
];


export function createEditProduct() {
  return observer(() => {
    useCheckPermission("EDIT")
    // ====================  STATE ===========================

    // Get the ID param from the URL
    const { productId = '' } = useParams();
    // const [status, setStatus] = useState('');
    // product detail
    const [productDetail, setProductDetail] = useState<ProductDetail | undefined>({
      categoryDetail2Name: '',
      parentCategoryName: '',
      categoryName: '',
      categoryDetailName: '',
      productCode: '',
      productName: '',
      serial: '',
      printMoldFilm: undefined,
      printMoldName: '',
      unit: '',
      moldDrawCode: '',
      bin: '',
      crrBin: '',
      locationNote: '',
      status: '',
      lastMaintenanceDate: new Date(),
      buyDate: new Date(),
      testDate: new Date(),
      usedDate: new Date(),
      lastMaintenanceDateStr: '',
      maintenanceAlert: 0,
      stampQuantity: 0,
      moldTest: '',
      currentStampQuantity: 0,
      stampQuantityAlert: 0,
      description: '',
      actived: false,
      isMold: false,
      productRoutings: [],
      specification: '',
      size: '',
      knifeType: '',
      equipmentType: '',
      productNum: '',
      vendor: '',
      oldCode: '',
      ghiChu: '',
    });

    const [listStatus, setListStatus] = useState<ListStatusProduct[]>([]);
    // get list dropdown moldtest
    const [listMoldTest, setListMoldTest] = useState<ListStatusProduct[]>([]);
    const [type, setType] = useState('');
    const [MoldTest, setTypeMoldTest] = useState('');
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, setValue } = useForm<EditProduct>();

    const Style = {
      '.MuiOutlinedInput-root': {
        padding: 0,
        borderRadius: 0,
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input[aria-controls]': {
        fontSize: '13px',
      },
    };

    // ============== FUNCTION ===========================================

    const handleChangeIsMoldTest = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setProductDetail({
        ...productDetail,
        moldTest: e.target.value,
      });
    };

    const handleChangeStampQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
      setProductDetail({
        ...productDetail,
        stampQuantity: Number(e.target.value),
      });
    };

    const navigate = useNavigate();
    const handleResetInput = () => {
      if (productDetail?.productName) {
        setProductDetail({
          ...productDetail,
          categoryDetail2Name: '',
          parentCategoryName: '',
          categoryName: '',
          categoryDetailName: '',
          productCode: '',
          productName: '',
          actived: false,
          isMold: false,
        });
        navigate(-1);
      } else {
        navigate(-1);
      }
    };

    // sự kiện thay đổi tình trạng khuôn

    const handleChangeStatus = (item: ListStatusProduct) => {
      {
        if (item.key === 'SD') {
          setProductDetail({
            ...productDetail,
            moldTest: '',
          });
        }
        if (item.key === 'TN') {
          setProductDetail({
            ...productDetail,
            moldTest: null,
          });
        }
        setType(item.key);
      }
    };

    const OnSubmit = async (data: EditProduct) => {
      setLoading(true);

      await rootStore.productPresenter.editProduct(rootStore.productStore, {
        productId: productId,
        lastMaintenanceDate: data.lastMaintenanceDate || null,
        buyDate: data.buyDate || null,
        testDate: data.testDate || null,
        usedDate: data.usedDate || null,
        maintenanceAlert: data.maintenanceAlert || null,
        currentStampeQuantity: data.currentStampeQuantity || null,
        stampQuantityAlert: data.stampQuantityAlert || null,
        actived: data.actived === 'active',
        status: data.status,
        moldTest: productDetail?.moldTest,
        ghiChu: data.ghiChu,

        moldDrawCode: data.moldDrawCode,
        printMoldFilm: data.printMoldFilm,
        printMoldName: data.printMoldName,
        bin: data.bin,
      });
      setLoading(false);
      if (rootStore.productStore.editProductResponse.isSuccess) {
        toast.success(rootStore.productStore.editProductResponse.message);
        // navigate(-1);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(rootStore.productStore.editProductResponse.message);
      }
    };

    useEffect(() => {
      const getProductDetail = async () => {
        await rootStore.productPresenter.getProductDetailById(rootStore.productStore, productId);

        if (rootStore.productStore.getProductDetailByIdResponse.isSuccess) {
          setProductDetail(rootStore.productStore.getProductDetailByIdResponse.data);

          setValue(
            'actived',
            rootStore.productStore.getProductDetailByIdResponse.data?.actived ? 'active' : 'unactive',
          );
          setValue('status', rootStore.productStore.getProductDetailByIdResponse.data?.status);
          // bản vẻ khuôn
          setValue('moldDrawCode', rootStore.productStore.getProductDetailByIdResponse.data?.moldDrawCode);
          // Mã film kiểm tra
          setValue('printMoldFilm', rootStore.productStore.getProductDetailByIdResponse.data?.printMoldFilm);
          // Mã film chụp bản
          setValue('printMoldName', rootStore.productStore.getProductDetailByIdResponse.data?.printMoldName);
          // bin
          setValue('bin', rootStore.productStore.getProductDetailByIdResponse.data?.bin);
        }
      };

      const getListStatusProduct = async () => {
        await rootStore.commonDatePresenter.getListStatusProduct(rootStore.commonDateStore);
        setListStatus(rootStore.commonDateStore.listStatusProductResponse.data);
      };

      getProductDetail();
      getListStatusProduct();
      getDropDownMoldTest();
    }, []);

    const getDropDownMoldTest = async () => {
      await rootStore.commonDatePresenter.getDropdownMoldTestResult(rootStore.commonDateStore, 'MoldTestResult');
      setListMoldTest(rootStore.commonDateStore.listStatusProductResponse.data);
    };

    // useEffect(() => {
    //   console.log(productDetail);
    // }, [productDetail]);

    useEffect(() => {
      productDetail?.status && setType(productDetail?.status);
    }, [productDetail?.status]);

    const addData = (date: string, num: number) => {
      const newdate = new Date(date);
      newdate.setDate(newdate.getDate() + num);
      return newdate.toString();
    };

    return (
      <div className="w-full py-3 px-5">
        <form onSubmit={handleSubmit(OnSubmit)}>
          <div className="w-full flex items-center mb-2 justify-between">
            <div className="flex items-center mb-3">
              <h3 className="text-md font-bold text-gray-800 uppercase">SỬA THÔNG TIN SẢN PHẨM</h3>
              {/* nút back */}
              <span
                onClick={handleResetInput}
                className="flex items-center text-xs text-primary cursor-pointer ml-3 font-medium"
              >
                <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
                Quay lại
              </span>
            </div>
            {/* Nút lưu và lưu tiếp tục */}
            <div className="flex">
              <button
                disabled={loading}
                className="flex items-center rounded-sm bg-primary text-white text-default py-1 px-2.5 mr-3"
              >
                <BiSave className="text-base mr-0.5" />
                Lưu
              </button>
            </div>
          </div>
          <div className="w-full bg-white py-3 flex rounded mb-2 border border-neutral-300">
            <div className="w-full flex flex-col mx-auto">
              <div className="w-full sm:w-3/5 mx-auto text-default">

                {/* Phân cấp sản phẩm */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Phân cấp sản phẩm
                  </label>
                  <input
                    disabled
                    value={productDetail?.parentCategoryName ? `${productDetail?.parentCategoryName}` : ''}
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* Nhóm sản phẩm */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Nhóm sản phẩm
                  </label>
                  <input
                    disabled
                    value={productDetail?.categoryName ? productDetail?.categoryName : ''}
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* Nhóm sản phẩm chi tiết */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Nhóm sản phẩm chi tiết
                  </label>
                  <input
                    disabled
                    value={productDetail?.categoryDetailName ? productDetail?.categoryDetailName : ''}
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>


                {/* Kiểu dáng sản phẩm */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Kiểu dáng sản phẩm
                  </label>
                  <input
                    disabled
                    value={productDetail?.categoryDetail2Name ? `${productDetail?.categoryDetail2Name}` : ''}
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* mã sản phẩm productCode*/}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Mã Sản Phẩm
                  </label>
                  <input
                    disabled
                    value={productDetail?.productCode ? productDetail?.productCode : ''}
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/*  Tên Sản phẩm*/}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Tên Sản phẩm
                  </label>
                  <input
                    disabled
                    value={productDetail?.productName ? productDetail?.productName : ''}
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* mo ta san pham */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Mô tả sản phẩm
                  </label>
                  <input
                    disabled
                    value={productDetail?.description ? productDetail?.description : ''}
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* don vi tinh */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Đơn vị tính
                  </label>
                  <input
                    value={productDetail?.unit ? productDetail?.unit : ''}
                    disabled
                    className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* Ghi chú */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Ghi chú
                  </label>
                  <input
                    {...register('ghiChu')}
                    onChange={(e) => {
                      setProductDetail({
                        ...productDetail,
                        ghiChu: e.target.value,
                      });
                    }}
                    value={productDetail?.ghiChu || ''}
                    className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {productDetail?.isMold && (
                  <div>
                    {/* ma ban ve khuon */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Bản vẽ khuôn
                      </label>
                      <input
                        // disabled
                        {...register('moldDrawCode')}
                        // value={productDetail?.moldDrawCode ? `${productDetail?.moldDrawCode}` : ''}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*Serial*/}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Serial
                      </label>
                      <input
                        disabled
                        value={productDetail?.serial ? `${productDetail?.serial}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*  Tình trạng khuôn*/}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Tình trạng khuôn
                      </label>
                      <div className="flex py-1.5 text-default col-span-5 lg:col-span-4">
                        {listStatus.map((item) => (
                          <div key={item.key} className="mr-5 flex items-center justify-center">
                            <input
                              {...register('status')}
                              id={`${item.key}`}
                              type="radio"
                              name="status"
                              checked={type === item.key}
                              className="mr-2"
                              value={item.key}
                              onChange={() => handleChangeStatus(item)}
                            />
                            <label htmlFor={`${item.key}`}>{item.value}</label>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* ma film kiem tra */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Mã film kiểm tra
                      </label>
                      <input
                        {...register('printMoldFilm')}
                        // value={productDetail.printMoldFilm}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*    Mã film chụp bản */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Mã film chụp bản
                      </label>
                      <input
                        {...register('printMoldName')}
                        // value={productDetail.printMoldName && `${productDetail.printMoldName}`}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* kho khuôn */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Kho khuôn
                      </label>
                      <input
                        disabled
                        value={productDetail.locationNote ? `${productDetail.locationNote}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Bin */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Bin
                      </label>
                      <input
                        {...register('bin')}
                        // value={productDetail.bin && `${productDetail.bin}`}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Current Bin */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Current Bin
                      </label>
                      <input
                        disabled
                        value={productDetail.crrBin ? `${productDetail.crrBin}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>

                    {/* Kích Thước / Quy Cách */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Kích Thước / Quy Cách
                      </label>
                      <input
                        disabled
                        value={productDetail.specification ? `${productDetail.specification}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Kích Thước / Quy Cách SP */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Kích Thước / Quy Cách SP
                      </label>
                      <input
                        disabled
                        value={productDetail.size ? `${productDetail.size}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>

                    {/* Loại dao */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Loại dao
                      </label>
                      <input
                        disabled
                        value={productDetail.knifeType ? `${productDetail.knifeType}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Loại máy bế */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Loại máy bế
                      </label>
                      <input
                        disabled
                        value={productDetail.equipmentType ? `${productDetail.equipmentType}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Số SP/Khuôn */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Số SP/Khuôn
                      </label>
                      <input
                        disabled
                        value={productDetail.productNum ? `${productDetail.productNum}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Tên nhà cung cấp */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Tên nhà cung cấp
                      </label>
                      <input
                        disabled
                        value={productDetail.vendor ? `${productDetail.vendor}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Mã cũ */}
                    <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Mã cũ
                      </label>
                      <input
                        disabled
                        value={productDetail.oldCode ? `${productDetail.oldCode}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>

                    {/* Thử ngiệm khuôn */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Thử nghiệm khuôn
                      </label>
                      <select
                        {...register('MoldTest')}
                        onChange={handleChangeIsMoldTest}
                        value={productDetail.moldTest !== undefined ? `${productDetail.moldTest}` : ''}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default w-full focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      >
                        <option className="" value="" disabled>
                          -- Chọn thử nghiệm khuôn --
                        </option>
                        {listMoldTest?.map((item, index) => {
                          return (
                            <option key={index} value={item.key}>
                              {item.value}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    {/* Ngày mua mới */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Ngày mua mới
                      </label>
                      <input
                        {...register('buyDate')}
                        type="date"
                        onChange={(e) => {
                          setProductDetail({
                            ...productDetail,
                            buyDate: e.target.value,
                          });
                        }}
                        value={moment(productDetail.buyDate).format('YYYY-MM-DD')}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Ngày thử nghiệm */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Ngày thử nghiệm
                      </label>
                      <input
                        {...register('testDate')}
                        type="date"
                        onChange={(e) => {
                          setProductDetail({
                            ...productDetail,
                            testDate: e.target.value,
                          });
                        }}
                        value={moment(productDetail.testDate).format('yyyy-MM-DD')}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Ngày đưa vào sử dụng */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Ngày đưa vào sử dụng
                      </label>
                      <input
                        type="date"
                        {...register('usedDate')}
                        onChange={(e) => {
                          setProductDetail({
                            ...productDetail,
                            usedDate: e.target.value,
                          });
                        }}
                        value={moment(productDetail.usedDate).format('yyyy-MM-DD')}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Ngày bảo trì gần nhất */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Ngày bảo trì gần nhất
                      </label>
                      <input
                        {...register('lastMaintenanceDate')}
                        onChange={(e) => {
                          setProductDetail({
                            ...productDetail,
                            lastMaintenanceDate: e.target.value,
                          });
                        }}
                        value={moment(productDetail.lastMaintenanceDate).format('yyyy-MM-DD')}
                        type="date"
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/* Cảnh báo bảo trì(số ngày) */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Cảnh báo bảo trì(số ngày)
                      </label>
                      <input
                        {...register('maintenanceAlert')}
                        onChange={(e) => {
                          setProductDetail({
                            ...productDetail,
                            maintenanceAlert: Number(e.target.value),
                          });
                        }}
                        value={productDetail.maintenanceAlert && `${productDetail.maintenanceAlert}`}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*  Ngày bảo trì tiếp theo */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Ngày bảo trì tiếp theo
                      </label>
                      <input
                        disabled
                        value={moment(
                          addData(
                            productDetail.lastMaintenanceDate,
                            productDetail.maintenanceAlert ? productDetail.maintenanceAlert : 0,
                          ),
                        ).format('DD/MM/yyyy')}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*   Cảnh báo bảo trì (số lần dập) */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Cảnh báo bảo trì (số lần dập)
                      </label>
                      <input
                        {...register('stampQuantityAlert')}
                        onChange={(e) => {
                          setProductDetail({
                            ...productDetail,
                            stampQuantityAlert: Number(e.target.value),
                          });
                        }}
                        value={productDetail.stampQuantityAlert && `${productDetail.stampQuantityAlert}`}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*    Số lượng dập lũy kế */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Số lượng dập lũy kế
                      </label>
                      <input
                        disabled
                        onChange={handleChangeStampQuantity}
                        value={productDetail.stampQuantity ? `${productDetail.stampQuantity}` : ''}
                        className="col-span-5 lg:col-span-4 disabled:bg-gray-300 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                    {/*  Số lượng dập hiện tại */}
                    <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                      <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                        Số lượng dập hiện tại
                      </label>
                      <input
                        {...register('currentStampeQuantity')}
                        onChange={(e) => {
                          setProductDetail({
                            ...productDetail,
                            currentStampQuantity: Number(e.target.value),
                          });
                        }}
                        value={productDetail.currentStampQuantity && `${productDetail.currentStampQuantity}`}
                        className="col-span-5 lg:col-span-4 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      />
                    </div>
                  </div>
                )}
                {/* Trạng thái */}
                <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-5 lg:gap-2">
                  <label className="font-bold col-span-5 lg:col-span-1 text-gray-700 text-left lg:text-right">
                    Trạng thái
                  </label>
                  <div className="flex py-1.5 text-default col-span-5 lg:col-span-4">
                    {activeOptions.map((item) => (
                      <div key={item.key} className="mr-5 flex items-center justify-center">
                        <input
                          {...register('actived')}
                          id={item.key}
                          type="radio"
                          name="actived"
                          className="mr-2"
                          value={item.key}
                          onChange={() => {
                            setProductDetail({
                              ...productDetail,
                              actived: item.key === 'active',
                            });
                          }}
                        />
                        <label htmlFor={item.key}>{item.value}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  });
}
